/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description reusable constants for app usage
 */
import { UiFieldTypeEnum } from '@jeeves/apis/generated/models';
const JEEVES_PRIMARY_COLOR = '#1d7bb9';
const MAX_MARKERS_TO_SHOW = 5;

const MONTH_NAME_DATE_YEAR = 'MMM DD,YYYY';
const ISO_DATE_FORMAT = 'YYYY-MM-DD';
const TIME_ZONE = 'America/Los_Angeles';
const DATE_FORMAT = 'MMM DD, YYYY';
const TIME_FORMAT = 'hh:mm A';

const DEFAULT_PAGE_SIZE = 100;
const DEFAULT_PAGE_SIZE_OPTIONS = [20, 50, 100];
const BATCH_USERS_PAGE_SIZE = 10;
const DEFAULT_APP_NAME = 'Jeeves';
const DEFAULT_TENANT_NAME = 'test7';
const DEFAULT_ZOOM_IN_OUT_DURATION = 0.8;

const FILLER_WORDS = [
	'a',
	'an',
	'and',
	'are',
	'as',
	'at',
	'be',
	'but',
	'by',
	'for',
	'if',
	'in',
	'into',
	'is',
	'it',
	'no',
	'not',
	'of',
	'on',
	'or',
	'such',
	'that',
	'the',
	'their',
	'then',
	'there',
	'these',
	'they',
	'this',
	'to',
	'was',
	'will',
	'with',
];

const singleSelection = 'Single selection dropdown';
const multiSelection = 'Multiple selection dropdown';
const textbox = 'Textbox';
const datePicker = 'Date picker';
const learner = 'Learner';

const CUSTOM_FIELD_INPUT_TYPES: UiFieldTypeEnum[] = [singleSelection, multiSelection, textbox, datePicker];

const THEME_COLORS = {
	COMPLETED: '#6E8185',
	TRASH_BIN: '#C1C1C1',
	PANEL_COLOR: '#F3F6F7',
	TASKS_COUNTER: '#6E8185',
	TIMELINE_BUTTON: '#006585',
	PDF: '#E03422',
	TEXT: '#2D393E',
	DISABLED: '#C1C1C1',
	BORDER: '#D9D9D9',
	LABEL: '#747474',
	PLACEHOLDER: 'rgba(0, 0, 0, 0.25)',
};

const LMS_COOKIE = {
	resource: 'resource',
	timestamp: 'timestamp',
	mac: 'mac',
};

const NOTIFICATION_PREFERENCES = {
	FEEDBACK_CREATED: 'jeeves-feedback-created',
	ASSIGNMENT_DUE_IN_1_DAY: 'jeeves-assignment-due-in-1-day',
	ASSIGNMENT_DUE_IN_7_DAYS: 'jeeves-assignment-due-in-7-days',
	ASSIGNMENT_DUE_IN_15_DAYS: 'jeeves-assignment-due-in-15-days',
	ASSIGNMENT_OVERDUE: 'jeeves-assignment-overdue',
	ASSET_EXPIRED: 'jeeves-asset-expired',
	ASSET_PUBLISHED: 'jeeves-asset-published',
	ASSET_EXPIRING_IN_1_DAY: 'jeeves-asset-expiring-in-1-day',
	ASSET_EXPIRING_IN_7_DAYS: 'jeeves-asset-expiring-in-7-days',
	ASSET_EXPIRING_IN_15_DAYS: 'jeeves-asset-expiring-in-15-days',
	ASSET_EXPIRING_IN_30_DAYS: 'jeeves-asset-expiring-in-30-days',
};

const DEFAULT_BACKGROUND_MUSIC_VOLUME = 0.08;

export {
	BATCH_USERS_PAGE_SIZE,
	CUSTOM_FIELD_INPUT_TYPES,
	DEFAULT_APP_NAME,
	DEFAULT_PAGE_SIZE,
	DEFAULT_PAGE_SIZE_OPTIONS,
	DEFAULT_TENANT_NAME,
	FILLER_WORDS,
	ISO_DATE_FORMAT,
	LMS_COOKIE,
	MAX_MARKERS_TO_SHOW,
	MONTH_NAME_DATE_YEAR,
	NOTIFICATION_PREFERENCES,
	JEEVES_PRIMARY_COLOR,
	THEME_COLORS,
	datePicker,
	multiSelection,
	singleSelection,
	textbox,
	TIME_ZONE,
	DATE_FORMAT,
	TIME_FORMAT,
	learner,
	DEFAULT_ZOOM_IN_OUT_DURATION,
	DEFAULT_BACKGROUND_MUSIC_VOLUME,
};
